export default __webpack_public_path__ + "static/media/diamond-cut-5@2x.8d8e0b43.jpg";